/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorCoverBox as ResolvedLabradorCoverBox } from 'base/components/labrador/CoverBox';

export const LabradorCoverBox: typeof ResolvedLabradorCoverBox = withLabradorInstanceof((props) => {
    return <ResolvedLabradorCoverBox {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorCoverBoxProps = PropsFromComponent<typeof LabradorCoverBox>;
